import googleSheetsMiddleware from './GoogleSheets/index.js';

export const googleSheets = googleSheetsMiddleware;

export default [ googleSheets ]


// WEBPACK FOOTER //
// ./src/middleware/index.js